import { render, staticRenderFns } from "./review-card.vue?vue&type=template&id=bc576158&"
import script from "./review-card.vue?vue&type=script&lang=js&"
export * from "./review-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports